export default {
  deposit: {
    title: 'Deposit Management',
    depositNo: 'Deposit No.',
    merchant: 'Merchant',
    merchantName: 'Merchant Name',
    contractNo: 'Contract No.',
    depositType: 'Deposit Type',
    sourceType: 'Source',
    sourceNo: 'Source No.',
    totalAmount: 'Total Amount',
    deductedAmount: 'Deducted Amount',
    refundedAmount: 'Refunded Amount',
    balance: 'Available Balance',
    status: 'Status',
    receiveDate: 'Receive Date',
    receiveMethod: 'Payment Method',
    receiveVoucher: 'Receive Voucher',
    receiptNo: 'Receipt No.',
    remark: 'Remark',
    isIntention: 'Is Intention',
    convertedToContract: 'Converted to Contract',

    // Types
    type: {
      RENT_DEPOSIT: 'Rent Deposit',
      PROPERTY_DEPOSIT: 'Property Deposit',
      RENOVATION_DEPOSIT: 'Renovation Deposit',
      UTILITY_DEPOSIT: 'Utility Deposit',
      INTENTION_DEPOSIT: 'Intention Deposit'
    },

    // Sources
    source: {
      CONTRACT: 'Contract',
      RENOVATION: 'Renovation',
      UTILITY: 'Utility',
      INTENTION: 'Intention',
      MANUAL: 'Manual'
    },

    // Status
    statusName: {
      PENDING: 'Pending',
      COLLECTED: 'Collected',
      DEDUCTING: 'Deducting',
      REFUNDING: 'Refunding',
      REFUNDED: 'Refunded',
      CLOSED: 'Closed'
    },

    // Payment methods
    paymentMethods: {
      BANK_TRANSFER: 'Bank Transfer',
      CASH: 'Cash',
      CHECK: 'Check',
      OTHER: 'Other'
    },

    // Actions
    action: {
      receive: 'Receive',
      deduct: 'Deduct',
      refund: 'Refund',
      offsetApply: 'Apply Offset',
      convert: 'Convert',
      approve: 'Approve',
      reject: 'Reject',
      execute: 'Execute',
      cancel: 'Cancel',
      viewDetail: 'View Detail',
      printReceipt: 'Print Receipt'
    },

    // Record types
    recordType: {
      RECEIVE: 'Receive',
      DEDUCT: 'Deduct',
      REFUND: 'Refund',
      CONVERT: 'Convert',
      OFFSET: 'Offset'
    },

    // Reason types
    reasonType: {
      ARREARS: 'Arrears',
      BREACH: 'Breach',
      DAMAGE: 'Damage',
      NORMAL: 'Normal',
      OTHER: 'Other'
    },

    // Voucher types
    voucherType: {
      CONTRACT_CLAUSE: 'Contract Clause',
      ARREARS_RECORD: 'Arrears Record',
      BREACH_PHOTO: 'Breach Photo',
      DAMAGE_PHOTO: 'Damage Photo',
      PAYMENT_VOUCHER: 'Payment Voucher',
      REFUND_VOUCHER: 'Refund Voucher',
      RECEIVE_VOUCHER: 'Receive Voucher',
      OTHER: 'Other'
    },

    // Summary
    summary: {
      pending: 'Pending',
      collected: 'Collected',
      processing: 'Processing',
      deducting: 'Deducting',
      refunding: 'Refunding',
      completed: 'Completed',
      total: 'Total',
      countUnit: 'items'
    },

    // Form
    form: {
      amount: 'Amount',
      reasonType: 'Reason Type',
      reason: 'Description',
      relatedBill: 'Related Bill',
      voucher: 'Voucher File',
      targetDepositType: 'Target Type',
      bankAccount: 'Bank Account',
      executeVoucher: 'Execute Voucher'
    },

    // Tips
    tip: {
      noBalance: 'Insufficient available balance',
      hasArrears: 'Merchant has arrears, please handle first',
      uploadVoucher: 'Please upload at least one voucher file',
      confirmReceive: 'Receipt will be generated after confirmation. Continue?',
      confirmExecute: 'Amount will be deducted from deposit after execution. Continue?'
    },

    // Page titles
    pageTitle: {
      list: 'Deposit List',
      detail: 'Deposit Detail',
      receive: 'Receive Confirmation',
      deduct: 'Initiate Deduction',
      refund: 'Initiate Refund',
      offset: 'Apply Offset',
      convert: 'Convert Intention Deposit',
      timeline: 'Operation Records'
    }
  }
}
